import type { Maybe } from '@adornis/base/utilTypes.js';

export type SDInvoiceMailData = {
  invoiceProjectNumber: string;
  visitorAddress: 'house_of_labor' | 'bockenheim';
  invoiceTax: number;
  invoiceReceiverAddress: 'user' | 'med' | 'dentMed';
  invoiceKontierungsstempel: boolean;
  otherAttachement: Maybe<'ilv-formular'>;
};

export const SD_INVOICE_CONFIG = {
  intern: {
    invoiceProjectNumber: '64003000',
    visitorAddress: 'house_of_labor',
    invoiceTax: 0,
    invoiceReceiverAddress: 'user',
    invoiceKontierungsstempel: false,
    otherAttachement: 'ilv-formular',
  } satisfies SDInvoiceMailData,
  extern: {
    invoiceProjectNumber: '64120700',
    visitorAddress: 'house_of_labor',
    invoiceTax: 0,
    invoiceReceiverAddress: 'user',
    invoiceKontierungsstempel: false,
    otherAttachement: null,
  } satisfies SDInvoiceMailData,
  med: {
    invoiceProjectNumber: '64120700',
    visitorAddress: 'bockenheim',
    invoiceTax: 0,
    invoiceReceiverAddress: 'med',
    invoiceKontierungsstempel: false,
    otherAttachement: null,
  } satisfies SDInvoiceMailData,
  carolinum_med: {
    invoiceProjectNumber: '64120700',
    visitorAddress: 'bockenheim',
    invoiceTax: 0,
    invoiceReceiverAddress: 'dentMed',
    invoiceKontierungsstempel: false,
    otherAttachement: null,
  } satisfies SDInvoiceMailData,
};
